import { render } from "./DeviceDetails.vue?vue&type=template&id=ed177bd6&ts=true"
import script from "./DeviceDetails.vue?vue&type=script&lang=ts"
export * from "./DeviceDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__